module.exports = __webpack_public_path__ + "img/newsLogo2.5d2889f8.png";